import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import { PATH } from 'src/features/navigation/utils/constants';
import DeletePayStationFormModal from 'src/features/payment/components/forms/DeletePayStationFormModal';
import UpdatePayStationFormModal from 'src/features/payment/components/forms/UpdatePayStationFormModal';
import { paymentsMessages } from 'src/features/payment/utils/messages';
import { PayStation } from 'src/features/payment/utils/types';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellPayStationActions({ row }: CellContext<PayStation, unknown>) {
    const { formatMessage } = useIntl();
    const managePayStationsPermission = useHasPermissions([PERMISSION.MANAGE_PAY_STATIONS]);

    return (
        <div className="flex gap-1">
            <TooltipProvider>
                {managePayStationsPermission && (
                    <>
                        <Tooltip>
                            <UpdatePayStationFormModal
                                selectedPayStation={row.original}
                                semantics={{ entryName: formatMessage(paymentsMessages.payStation).toLowerCase() }}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdatePayStationFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        <Tooltip>
                            <DeletePayStationFormModal selectedPayStation={row.original}>
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                    </Button>
                                </TooltipTrigger>
                            </DeletePayStationFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.delete} />
                            </TooltipContent>
                        </Tooltip>
                    </>
                )}
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/${PATH.PAYMENTS}/pay-station/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
